import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountCMAReportsPreview implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCMAReportsPreviewContainer";
    }
    render(){
        let self=this;
        // console.log("cma-reports/preview");
        $(".previewPDF", this.zidx.peakidxShadowRoot).on("click", function(this, e:JQuery.ClickEvent){
            let cma_id=$(this).attr("data-cma-id");
            var modalContent1='<iframe src="/account/cma-reports/send?cma_id='+cma_id+'&preview=1"  style="margin:0px;border:none; overflow:auto;" seamless="seamless" width="100%" height="95%"><\/iframe>';
            // @ts-ignore
            self.zidx.modalWindow.showModal(modalContent1,{'width':self.zidx.windowSize.width-100,'height':self.zidx.windowSize.height-100});
        });
        $(".addressSpan1", this.zidx.peakidxShadowRoot).on("click", function(this, e:JQuery.ClickEvent){
            let listingId=$(this).attr("data-id");
            var modalContent1='<iframe src="/account/cma-reports/listing?listing_id='+listingId+'"  style="margin:0px;border:none; overflow:auto;" seamless="seamless" width="100%" height="95%"><\/iframe>';
            // @ts-ignore
            self.zidx.modalWindow.showModal(modalContent1,{'width':self.zidx.windowSize.width-100,'height':self.zidx.windowSize.height-100});
        });
    }
}